<script>
  import TimesList from '../../components/time/TimesList.svelte'

</script>

<div class="notifications">
  <div class="columns">
    <div class="column">
      <div class="content">
        <TimesList />
      </div>
    </div>
  </div>
</div>
